import { render, staticRenderFns } from "./LoginBg.vue?vue&type=template&id=a7325e08&"
import script from "./LoginBg.vue?vue&type=script&lang=js&"
export * from "./LoginBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports